<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page

========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">إستعادة كلمة المرور</h4>
                                    <p>أدخل كلمة المرور الجديدة.</p>
                                </div>
                                <div class="vx-row">
                                  <div class="vx-col w-full mb-4">
                                    <vs-input
                                      class="w-full mb-1" name="password" type="password" ref="password"
                                      label-placeholder="كلمة المرور"
                                      data-vv-as="كلمة المرور"
                                      v-validate="'required'"
                                      v-model="password" />

                                    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                                    <span class="text-danger block text-sm" v-show="errors.has('rgx-password')">{{ errors.first('rgx-password') }}</span>
                                  </div>
                                  <div class="vx-col w-full mb-4">
                                    <vs-input
                                      class="w-full mb-1" name="password_confirmation" type="password"
                                      label-placeholder="تأكيد كلمة المرور"
                                      data-vv-as="تأكيد كلمة المرور"
                                      v-validate="'required|confirmed:password'"
                                      v-model="password_confirmation" />

                                    <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
                                  </div>
                                </div>

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">تسجيل الدخول</vs-button>
                                    <vs-button class="w-full sm:w-auto" @click="resetPassword">إستعادة</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

    import authAPI from '@/api/authAPI'

export default {
    data() {
        return {
            email: this.$route.query.email,
            token: this.$route.query.token,
            password: '',
            password_confirmation: '',
        }
    },
    watch: {
        password(val) {
            const regx = new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))(?=.{8,})");
            if(val !== '' && !val.match(regx)) {
                this.$validator.errors.add({ field: "rgx-password", msg: 'يجب ان تحتوي كلمة المرور علي 8 أحرف علي الاقل ورقم وحرف كبير وحرف صغير' })
            } else {
                this.$validator.errors.remove("rgx-password")
            }
        }
    },
    methods: {
        resetPassword() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    authAPI.resetPassword(this.email, this.token, this.password, this.password_confirmation)
                        .then(({data}) => {
                            if(data.message === 'success') {
                                this.$router.push({path: '/login'})
                            }
                        }).catch(error => this.$notifyError(error.statusMessage))
                }
            })
        }
    }
}
</script>
